import React from 'react'

const Switch = ({
    checked = false,
    onChange,
    disabled = false,
}) => {
    return (
        <label className={`inline-flex items-center me-5 ${!disabled && "cursor-pointer"}`}>
            <input type="checkbox" value="" className="sr-only peer" disabled={disabled} checked={checked} onChange={onChange}  />
            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
        </label>
    )
}

export default Switch